export interface ProductUrlFields {
  id: string;
  categorySlug?: string;
  productSlug?: string;
}

export const PRODUCT_SITE_ORIGIN = "https://umasaura.com";

export const getProductPath = ({ id, categorySlug, productSlug }: ProductUrlFields): string => {
  if (categorySlug && productSlug) {
    return `/product/${encodeURIComponent(categorySlug)}/${encodeURIComponent(productSlug)}`;
  }
  return `/product/${encodeURIComponent(id)}`;
};

export const getCanonicalProductUrl = (product: ProductUrlFields): string => {
  if (!product.categorySlug || !product.productSlug) {
    throw new Error("Canonical product URL requires backend-provided slugs");
  }
  return `${PRODUCT_SITE_ORIGIN}/product/${encodeURIComponent(product.categorySlug)}/${encodeURIComponent(product.productSlug)}`;
};

export const getLegacyProductRedirect = (
  legacyProductId: string | undefined,
  product: ProductUrlFields
): string | null => {
  if (!legacyProductId || !product.categorySlug || !product.productSlug) return null;
  return getProductPath(product);
};

export const productMetaDescription = (name: string, description?: string): string => {
  const plain = (description || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
  const fallback = `Shop ${name} online at Uma's Aura. Explore authentic spiritual and wellness products.`;
  const value = plain || fallback;
  return value.length <= 160 ? value : `${value.slice(0, 157).trimEnd()}...`;
};
